import { render, staticRenderFns } from "./ShapeEditorControl.vue?vue&type=template&id=2e94a050&scoped=true"
import script from "./ShapeEditorControl.vue?vue&type=script&lang=js"
export * from "./ShapeEditorControl.vue?vue&type=script&lang=js"
import style0 from "./ShapeEditorControl.vue?vue&type=style&index=0&id=2e94a050&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e94a050",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e94a050')) {
      api.createRecord('2e94a050', component.options)
    } else {
      api.reload('2e94a050', component.options)
    }
    module.hot.accept("./ShapeEditorControl.vue?vue&type=template&id=2e94a050&scoped=true", function () {
      api.rerender('2e94a050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/ShapeEditorControl.vue"
export default component.exports